// Read-only descriptions of the hardcoded matching behavior in
// db/src/category/category_map.rs (`CategoryMap::lookup_by_fields`), so the full
// categorization logic is visible in-product — not just the editable pattern rules.

interface BuiltinBehavior {
  source_label: string
  behaviors: string[]
}

const BUILTIN_BEHAVIORS: BuiltinBehavior[] = [
  {
    source_label: "UNFI",
    behaviors: [
      "Invoice numbers are reduced to their stem before matching (e.g. trailing A/B variant letters are dropped).",
      "Retailer codes embedded in invoice numbers (e.g. “MOTHER”, “WGM”) are recognized and set the deduction's retailer.",
    ],
  },
  {
    source_label: "KeHE",
    behaviors: [
      "A leading “RP” prefix is stripped before matching.",
      "Dotted suffixes are tried progressively (SWN46212641.0326.01 → SWN46212641.0326 → SWN46212641).",
      "8-digit invoice numbers that equal the description are treated as Sprouts returns.",
    ],
  },
  {
    source_label: "Amazon",
    behaviors: ["When a rule has both an invoice pattern and a description pattern, both must match."],
  },
  {
    source_label: "Walmart & Hy-Vee",
    behaviors: ["The description is checked before the invoice number, so reason-code descriptions win over broad invoice patterns."],
  },
]

export function BuiltinRulesSection() {
  return (
    <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
      <div>
        <h2 class="text-lg font-semibold leading-7 text-gray-900">How categorization works</h2>
        <p class="text-sm text-gray-500 mt-1">
          Deductions are categorized in two passes. First, the pattern rules above run automatically when deductions are imported. Second,
          deductions that are still uncategorized are reviewed by BigWiz, which reads the backup documents and assigns one of
          your categories. You can always recategorize any deduction by hand — manual categories are never overwritten by rules.
        </p>
      </div>
      <div>
        <h3 class="text-sm font-semibold text-gray-900 mb-2">Built-in matching behavior</h3>
        <p class="text-sm text-gray-500 mb-3">These behaviors are part of the platform and apply before your pattern rules:</p>
        <ul class="space-y-2">
          {BUILTIN_BEHAVIORS.map((b) => (
            <li key={b.source_label} class="text-sm">
              <span class="font-medium text-gray-900">{b.source_label}:</span>
              <ul class="list-disc ml-5 text-gray-600">
                {b.behaviors.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
